















































































































































import { Vue, Component } from 'vue-property-decorator';
import RankList from '@/RankList';
import NewsList from '@/NewsList';
import FavoriteCard from '@/FavoriteCard';
import { getOrgDetail } from 'service/api';
import { OrganizationDetail, OrganizationDetailRes } from 'src/types/views/organization';

@Component({
  components: {
    RankList,
    NewsList,
    FavoriteCard,
  },
})
export default class Service extends Vue {
  fontSize = 14;

  center = [121.5559852123, 29.8079267992];

  detail: OrganizationDetail = {
    id: 0,
    name: '',
    servicetypename: '',
    serviceindustryname: '',
    serviceareaname: '',
    url: '',
    fulladdress: '',
    description: '',
    productDescription: '',
    serviceproduct: '',
    contacts: [],
    huojiangzhengshu: [],
    zizhizhengshu: [],
    product: [],
    favorite: false,
  };

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }

  async getDetail(id: string) {
    const res = await getOrgDetail({ id });
    const { data: { rows: data } } = res as OrganizationDetailRes;
    this.detail = {
      ...data,
      product: data.product ? data.product.map(item => ({
        ...item,
        createTime: item.createTime ? item.createTime.substr(0, 10) : '',
        description: item.description ? item.description.replace(/<[^>]+>|&.*?;|\s+/g, '') : '',
      })) : [],
    };
    const { fulladdress: address } = this.detail;
    if (address) {
      this.getLocation(address);
    }
  }

  getLocation(address: string) {
    AMap.plugin('AMap.Geocoder', () => {
      const geoCoder = new AMap.Geocoder();
      geoCoder.getLocation(address,
        (status: string,
          res: { info: string; geocodes: { location: {lng: number; lat: number} }[] }) => {
          if (status === 'complete' && res.info === 'OK') {
            const coordinate = res.geocodes[0].location;
            this.center = [coordinate.lng, coordinate.lat];
          }
        });
    });
  }

  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getDetail(id as string);
    }
  }
}
